<!--
  template(if) - list(show) 구조는 불필요한 로드를 방지하기 위해서임.
  refresh 는 add, edit 성공시 호출해야 함.
-->
<template>
  <div class="animated fadeIn" v-if="base">
    <vcl-facebook v-if="loading"></vcl-facebook>
    <template>
      <Site v-show="site_list && !loading" ref="list" @loading="(status) => loading = status" />
      <Result v-if="detail && !loading" @refresh="refresh" @loading="(status) => loading = status" />
    </template>
  </div>
</template>

<script>

import Site from './Site.List.i18n';
import Result from './Result.List.i18n';
import { VclFacebook } from 'vue-content-loading';

export default {
  components: { Site, VclFacebook, Result },
  data: () => ({ base: false, site_list: false, detail: false, loading : true }),
  methods: {
    refresh() { if(this.$refs.list) { this.$refs.list.children.forEach(ch => ch.refresh()) } },
    select({ site_id, result_id }) {
      if(!site_id) { this.site_list = !(this.detail = false); }
      else { this.detail = !(this.site_list = false); }
      // this.base = (site_id || result_id)
      this.base = true
    }
  },
  created: function() {   console.log('result.vue', 'created'); },
  destroyed: function() { console.log('result.vue', 'destroyed'); },
  mounted: function() { console.log('result.vue', 'mounted'); this.select(this.$route.params); },
  watch: {
    '$route' (to, from) {
      console.log('result.vue', 'route changed', to.param);
      this.select(to.params);
    }
  },
}
</script>
